import { type ConditionOperation } from '~/gql/graphql'
import { type TranslationSchema } from '~/locales/resources'

export const conditionOperations = [
  'equal',
  'not_equal',
  'in',
  'not_in',
] as const satisfies readonly ConditionOperation[]

export const conditionOperationLabelI18nKeyMap = {
  equal: 'equal_to',
  not_equal: 'not_equal_to',
  in: 'contains_any',
  not_in: 'does_not_contain',
} as const satisfies Record<ConditionOperation, keyof TranslationSchema>
